import { ItemConfigsContext } from "../../context/ItemConfigContext"
import { useContext } from "react"

export const useItemConfigContext = () => {
  const context = useContext(ItemConfigsContext)

  if(!context) {
    throw Error('useItemConfigContext must be used inside an ItemConfigsContextProvider')
  }

  return context
}